import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,_vm._g(_vm._b({staticClass:"mb-4",attrs:{"height":_vm.height,"width":_vm.width,"flat":"","tile":""},on:{"click":function($event){return _vm.$emit('click')}}},'v-card',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2),(_vm.title)?_c('base-title',{staticClass:"text-uppercase",attrs:{"title":_vm.title,"size":"subtitle-1","space":"0"}}):_vm._e(),(_vm.subtitle)?_c('base-subtitle',{attrs:{"title":_vm.subtitle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }